import {
  BottomNavigationAction,
  type BottomNavigationActionProps,
  type SxProps,
  type Theme,
} from "@mui/material";
import { useIsTablet } from "Hooks/useIsTablet";
import type { FC } from "react";
import { useTheme } from "styled-components";

export type BottomApplicationLink = {
  isAction?: boolean;
} & Pick<
  BottomNavigationActionProps,
  "label" | "action" | "icon" | "disabled" | "value"
>;

type Props = BottomApplicationLink;

const BottomNavigationActionStyles: SxProps<Theme> = {
  fontWeight: 300,
  span: { fontSize: "0.625rem !important" },
  "&.MuiBottomNavigationAction-root": {
    gap: 1,
  },

  svg: { fill: (theme) => theme.palette.grey[600] },

  "&.Mui-selected": {
    color: (theme) => theme.palette.primary.main,
    svg: {
      fill: (theme) => theme.palette.primary.main,
    },
  },
};

export const BottomMenuItem: FC<Props> = ({ isAction, ...props }) => {
  const theme = useTheme();
  const isTablet = useIsTablet();

  return (
    <BottomNavigationAction
      {...props}
      sx={{
        width: "100%",
        minWidth: "unset",
        padding: "unset",
        ...(isTablet ? { flexGrow: 0 } : {}),
        ...BottomNavigationActionStyles,
        ...(isAction && {
          background: theme.palette.primary.main,
          borderRadius: "4px",
          color: `${theme.palette.common.white} !important`,
          "&.Mui-disabled": {
            color: `${theme.palette.grey[600]} !important`,
            background: theme.palette.grey[300],
          },
          svg: {
            fill: theme.palette.common.white,
          },
          "&.Mui-selected": {
            svg: {
              fill: theme.palette.common.white,
            },
          },
        }),
      }}
    />
  );
};
